import { render, staticRenderFns } from "./ClientEmailSettings.vue?vue&type=template&id=dc39979e&"
import script from "./ClientEmailSettings.vue?vue&type=script&lang=js&"
export * from "./ClientEmailSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports